import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesLeft, faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import { PUBLIC_HOME_PATH } from "../routes/public-home-path";

type AppSidebarHeaderProps = {
  readonly collapsed: boolean;
  readonly toggleCollapsed: () => void;
  readonly navId: string;
  readonly workspaceLabel: string;
  readonly email: string;
};

export function AppSidebarHeader({
  collapsed,
  toggleCollapsed,
  navId,
  workspaceLabel,
  email,
}: AppSidebarHeaderProps) {
  return (
    <>
      <div className="app-sidebar-head">
        <button
          type="button"
          className="app-sidebar-toggle"
          onClick={toggleCollapsed}
          aria-expanded={!collapsed}
          aria-controls={navId}
          aria-label={collapsed ? "Expand navigation" : "Collapse navigation"}
          title={collapsed ? "Expand navigation" : "Collapse navigation"}
        >
          <FontAwesomeIcon icon={collapsed ? faAnglesRight : faAnglesLeft} fixedWidth />
        </button>
      </div>
      <Link
        to={PUBLIC_HOME_PATH}
        className="app-sidebar-brand"
        aria-label="Code Create Slay home"
        title={collapsed ? "Code Create Slay home" : undefined}
      >
        <img className="app-sidebar-brand-logo" src="/logo.png" alt="" width={44} height={44} />
        <span className="app-sidebar-brand-name">Code Create Slay</span>
      </Link>
      <div className="app-sidebar-workspace">{workspaceLabel}</div>
      <div className="app-sidebar-email">{email}</div>
    </>
  );
}
